import React from "react";
import { CrossIcon } from "../../assets/Icons/CrossIcon";
import styles from "./styles.module.scss";

/**
 * @param {{
 *  children: React.ReactNode;
 *  onRemove?: () => void;
 * }} param0
 */
export function Badge({ children, onRemove }) {
  return (
    <div className={styles.root}>
      <span>{children}</span>
      {onRemove && (
        <button onClick={() => onRemove()}>
          <CrossIcon width="15px" />
        </button>
      )}
    </div>
  );
}
